var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.svg#trash--J8fYY';
                    var viewUrl = 'sprites.svg#view-trash--J8fYY';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 12 14',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };